/**
 * Created by Sergii on 01.10.2018.
 */
import {combineReducers} from "redux";
import usersTable from "./UsersTableReducer";
import userDetails from "./UserDetailsReducer";
import newUser from "./NewUserReducer";
import messageBox from "./MessageBoxReducer";
import ambryKey from "./AmbryKeyReducer";
import changePassword from "./ChangePasswordReducer"
import folders from './Folders';
import formats from './Formats';
import {i18nReducer} from 'react-redux-i18n';

export default combineReducers({
    newUser,
    ambryKey,
    usersTable,
    userDetails,
    messageBox,
    changePassword,
    folders,
    formats,
    i18n: i18nReducer
});